import React, { useContext } from "react";

export const BankingContext = React.createContext(null);

export const BankingContentProvider = ({ children, pageData }) => {
  return (
    <BankingContext.Provider value={pageData}>
      {children}
    </BankingContext.Provider>
  );
};

export const useBankingContent = () => {
  return useContext(BankingContext);
};



// WEBPACK FOOTER //
// ./src/banking/BankingContentContext.js